import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dropdown",
    "currentRegionText",
    "metricContent",
    "imperialContent",
    "euContent",
    "usContent",
  ]
  static values = {
    currentRegion: String,
    defaultRegion: { type: String, default: "us" },
  }

  connect() {
    // Initialize region from localStorage or default to EU
    const savedRegion = localStorage.getItem("windrose-region") || this.defaultRegionValue
    this.currentRegionValue = savedRegion

    // Close dropdown when clicking outside
    document.addEventListener("click", this.closeDropdownOnClickOutside.bind(this))

    this.updateRegionDisplay()
    this.updateVisibility()
  }

  disconnect() {
    document.removeEventListener("click", this.closeDropdownOnClickOutside.bind(this))
  }

  toggleDropdown(event) {
    this.dropdownTarget.classList.toggle("hidden")
    event.stopPropagation()
  }

  closeDropdownOnClickOutside(event) {
    if (this.hasDropdownTarget && !this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  // Called when region is changed via button
  setRegionFromButton(event) {
    const newRegion = event.currentTarget.dataset.region
    this.setRegion(newRegion)
    this.dropdownTarget.classList.add("hidden")
    event.preventDefault()
  }

  // Core method to update region
  setRegion(newRegion) {
    if (this.currentRegionValue === newRegion) return

    this.currentRegionValue = newRegion
    localStorage.setItem("windrose-region", newRegion)

    this.updateRegionDisplay()
    this.updateVisibility()

    // Dispatch custom event for other components to react
    const event = new CustomEvent("region-changed", {
      detail: { region: newRegion },
      bubbles: true,
    })
    this.element.dispatchEvent(event)
  }

  // Update region display in UI
  updateRegionDisplay() {
    if (this.hasCurrentRegionTextTarget) {
      // Update region text
      const regionTextMap = {
        eu: "EU",
        us: "US",
      }
      this.currentRegionTextTarget.textContent = regionTextMap[this.currentRegionValue] || "US"
    }
  }

  // Show/hide content based on region
  updateVisibility() {
    // Handle metric/imperial content
    if (this.hasMetricContentTarget) {
      this.metricContentTargets.forEach((el) => {
        el.classList.toggle("hidden", !["eu"].includes(this.currentRegionValue))
      })
    }

    if (this.hasImperialContentTarget) {
      this.imperialContentTargets.forEach((el) => {
        el.classList.toggle("hidden", this.currentRegionValue !== "us")
      })
    }

    // Handle region-specific content
    if (this.hasEuContentTarget) {
      this.euContentTargets.forEach((el) => {
        el.classList.toggle("hidden", this.currentRegionValue !== "eu")
      })
    }

    if (this.hasUsContentTarget) {
      this.usContentTargets.forEach((el) => {
        el.classList.toggle("hidden", this.currentRegionValue !== "us")
      })
    }
  }
}

